/**
 * The clock leaf (unit convention §1).
 *
 * `side` is the one discriminator prop, and it is a constant per mount (the two
 * player rows are created once), so it cannot propagate a parent render.
 */
import React from 'react';

import type {Side} from '@/Store/liveGame/state';

import {bump} from '../renderCount';
import {useClockModel} from './model';
import ClockView from './View';

export {LOW_TIME_MS, format} from './format';

export default React.memo(function Clock({side}: {side: Side}) {
  bump('Clock');
  return <ClockView side={side} {...useClockModel(side)} />;
});
